<div class="card">
  <div class="boost flex justify-between md:flex-col">
    <div class="boost__col">
      <div class="text-18 font-weight-800 uppercase md:text-14">
        {{ 't.boost-bonus-title' | translate }}
      </div>
      <div
        class="text-32 font-weight-800 text-gradient uppercase md:text-16 mb-10 mt-10">
        {{ 't.boost-bonus-prize' | translate }}
      </div>
      <div class="text-12 font-weight-500 md:w-50">
        {{ 't.boost-bonus-desc' | translate }}
      </div>
      <div>
        @if (customBonus.state().bonusBoostBonus.isShowBonusBoostActiveBonus) {
          <div class="text-12 mt-14 mb-8 md:mt-28 secondary-color">
            {{ 't.time-left' | translate }}
            : {{ customBonus.remainingTime() }}&nbsp;{{ customBonus.remainingTime() === 1 ? ('t.minute' | translate) : ('t.minutes' | translate) }}
            /
            {{ customBonus.state().bonusBoostBonus.bonusBoostLimitTime / 60000 }}&nbsp;{{ 't.minutes' | translate }}
            ({{ customBonus.elapsedTimePercentage() + '%' }})
          </div>
          <div class="progress-bar w-50 md:mb-20">
            <div class="progress" [ngStyle]="{width: customBonus.elapsedTimePercentage() + '%'}"></div>
          </div>
        }
      </div>
    </div>
    <div class="boost__col md:flex flex-col-reverse">
      <div class="flex gap-12">
        <button (click)="customBonus.cancelBonusBoost()" class="btn small cancel">
          {{ 'btn.cancel' | translate }}
        </button>
        @if (!customBonus.state().bonusBoostBonus.isShowBonusBoostActiveBonus) {
          <button (click)="customBonus.activateBonusBoost()" class="btn small activate">
            {{ 'btn.activate' | translate }}
          </button>
        }
        @if (customBonus.state().bonusBoostBonus.isShowBonusBoostActiveBonus) {
          <button routerLink="/games" class="btn small activate">
            {{ 'btn.play' | translate }}
          </button>
        }
      </div>
      <div class="status-block flex justify-end mt-20 md:mb-10">

        @if (!customBonus.state().bonusBoostBonus.isShowBonusBoostActiveBonus) {
          <div class="text-12 mr-24 md:mr-0 status">{{ 't.available' | translate }}</div>
        }
        @if (customBonus.state().bonusBoostBonus.isShowBonusBoostActiveBonus) {
          <div class="text-12 mr-24 md:mr-0 active status">{{ 't.active' | translate }}</div>
        }
        @if (!customBonus.state().bonusBoostBonus.isShowBonusBoostActiveBonus) {
          <div class="text-12 md:mt-50">
            <span class="secondary-color">{{ 't.finished-in' | translate }}:&nbsp;</span>
            {{ customBonus?.endTime() }}
          </div>
        }
      </div>
    </div>
    <div class="boost__col">
      <img src="/assets/img/boost-points.png" alt="">
    </div>
  </div>
</div>
